import React, {Component} from 'react';
import axios from 'axios';
import config from "../config";
import i18n from "../i18n";
import SearchView from "../views/SearchView";
import {withError} from "cw-styleguide-react";

class SearchController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: ''
    };
  }

  componentDidMount() {
    axios.get(config.endpoints.apprenticeshipSearchSettings[i18n.language], {
      params: {
        time: Date.now()
      }
    })
    .then(response => {
      this.setState({
        content: response.data.content,
      });
    })
    .catch(error => {
      this.props.setError(error);
    });

    // Reset the filters whenever returning the search page.
    this.props.resetFilters();
    this.props.setFilter('page', 1);
    this.props.setFilter('sort', 'closingDateAsc');
    this.props.setFilter('groupSize', 10);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      typeof window.initialiseAccordion === 'function' &&
      typeof window.initialiseDocumentDownload === 'function' &&
      typeof window.initialiseCardInfographic === 'function' &&
      typeof window.initialiseShowMoreLess === 'function' &&
      typeof window.initialiseAnchor === 'function'
    ) {
      window.initialiseAccordion();
      window.initialiseDocumentDownload();
      window.initialiseCardInfographic();
      window.initialiseShowMoreLess();
      window.initialiseAnchor();
    }
  }

  render() {
    return <SearchView {...this.props} {...this.state}/>;
  }
}

export default withError(SearchController);
